<template>
  <div class="expert-billing-banner">
    <BasicSection appearance="same-paddings">
      <h2 class="expert-billing-banner__title">Продвигайте экспертизу</h2>
      <div class="expert-billing-banner__description">
        Стройте личный бренд и увеличивайте эффективность профиля эксперта на Хабр Карьере.
      </div>
      <button
        title="Закрыть баннер"
        class="expert-billing-banner__close"
        @click="$emit('closeBanner')"
      >
        <SvgIcon icon="cross" size="16" />
      </button>
        <BasicButton
          type="button"
          appearance="primary"
          size="m"
          href="/profile/expert/billing"
        >
          Узнать больше
        </BasicButton>
    </BasicSection>
  </div>
</template>

<script>
  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';

  export default {
    name: 'ExpertBillingBanner',
    components: {
      BasicButton,
      BasicSection,
      SvgIcon
    },
    emits: ['closeBanner'],
    data() {
      return {
        cancelled: false,
        showMessage: false,
        isLoading: false,
        score: null,
        modalVisible: false,
      }
    },
  };
</script>
